import QueryPage from './QueryPage'
import QuerySearch from './QuerySearch'
import QueryList from './QueryList'

export { QueryPage, QueryList, QuerySearch };



// WEBPACK FOOTER //
// ./src/areas/shared/pages/query/index.js